import { WeaTableNew,WeaSwitch } from 'comsMobx';
let WeaTable = WeaTableNew.WeaTable;
import {Form, Input, Button, Select, Switch, Tabs} from 'antd';
import {WeaDialog, WeaSearchGroup, WeaInput,WeaBrowser,WeaTab,WeaTools,WeaNewScroll, WeaFormItem} from 'ecCom';
import {inject, observer} from "mobx-react";
import {toJS} from 'mobx';
import CoworkConstant from '../../../util/CoworkConstant';
import _mapValues from 'lodash/mapValues'
const TabPane = Tabs.TabPane;
const Option = Select.Option;
import {WeaLocaleProvider, WeaMoreButton} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

@inject("coworkMainStore")
@observer
class LogDialog extends React. Component {
  constructor(props) {
    super(props);
    this.state = {
      title:getLabel(17480, '查看日志'),
      closable:true,
      maskClosable:true,
      icon:'icon-coms-cowork',
      showSearchAd:false,
      dialogStyle:{
        width: 700,
        height: 510
      },
      height: 510
    }
  }
  
  componentWillReceiveProps(nextProps) {
	const {coworkMainStore} = this.props;
    coworkMainStore.clearFormFields();
    let visible = nextProps.visible;
    if (visible && visible != this.props.visible) {
      const { id } =  nextProps.coworkMainStore.content ;
      nextProps.coworkMainStore.getLog({coworkId:id,currentpage:'1'});
      nextProps.coworkMainStore.getLogViewCondition();
    }
  }

   componentWillUnmount() {
    const {coworkMainStore} = this.props;
    coworkMainStore.clearFormFields();
   }

  render() {
    const { coworkMainStore, visible, showLogDialog } = this.props,{logTableStore} = coworkMainStore;;
    let buttons = [
       (<Button onClick={this.back} type="primary">{getLabel(1290,'返回')}</Button>),
       (<Button type="primary" disabled={false} onClick={() => {this.exportExcel()}}>{getLabel(28343, '导出Excel')}</Button>),
      (<WeaMoreButton />)
    ];
    const { sessionkey,cond } = coworkMainStore.content;
	  const { title , closable , maskClosable, icon, showSearchAd, dialogStyle, height } = this.state;
	
	return (
      <div>
        <WeaDialog
          title={title}
          visible={visible}
          buttons={buttons}
          closable={closable}
          maskClosable={maskClosable}
          icon={CoworkConstant.iconClassName} iconBgcolor={CoworkConstant.iconBgColor}
          onCancel={this.back}
          style={dialogStyle}
          onChangeHeight={this.changeHeight}
        >
          <WeaTab
            searchType={['advanced']}
            onSearch={this.baseSearch}
            showSearchAd={this.state.showSearchAd}
            searchsAd={ <Form horizontal>{this.getSearchs()}</Form>}
            setShowSearchAd={bool=>{this.setState({showSearchAd: bool})}}
            buttonsAd={this.getTabButtonsAd()}
          />
          {
            visible && 
            <WeaTable
              sessionkey = {sessionkey}
              comsWeaTableStore={logTableStore}
              scroll={{y: height-125}}
            />
          }
            {/* <WeaTable
              sessionkey = {sessionkey}
              comsWeaTableStore={logTableStore}
              scroll={{y: height-125}}
            /> */}
        </WeaDialog>
      </div>)
  }

  //高级搜索group定义
  getSearchs() {
    const { coworkMainStore } = this.props;
    const { logViewCondition } = toJS(coworkMainStore.content);
    const { logTableForm } = coworkMainStore;
    let group = [];
    logViewCondition && logViewCondition.length>0 &&logViewCondition.map(c =>{
        let items = [];
        c.items.map(fields => {
        items.push({
          com:(
          <WeaFormItem
            label={`${fields.label}`}
            labelCol={{span: `${fields.labelcol}`}}
            wrapperCol={{span: `${fields.fieldcol}`}}
            >
            {/* { WeaTools.getComponent(fields.conditionType, fields.browserConditionParam, fields.domkey, this.props, fields) } */}
            <WeaSwitch fieldConfig={fields} form={logTableForm}/>
          </WeaFormItem>
          ),
          colSpan:1
        })
        });
        group.push(<WeaSearchGroup needTigger={true} title={c.title} showGroup={c.defaultshow} items={items}/>)
    });
    return group
  }

  //定义tab中点击高级搜索时的最下面的操作按钮集合
  getTabButtonsAd() {
    return [
      (<Button type="primary" onClick={this.search}>{getLabel(197, '搜索')}</Button>),
      (<Button type="ghost" onClick={this.resetSearch}>{getLabel(2022, '重置')}</Button>),
      (<Button type="ghost" onClick={this.cancelSearch}>{getLabel(201, '取消')}</Button>)
    ]
  }

  //获取高级搜索条件
  search = (e) => {
    e.preventDefault();
    const {coworkMainStore} = this.props;
    let { id } = coworkMainStore.content;
    coworkMainStore.getLog({coworkId:id,currentpage:'1'});
    this.cancelSearch();
  }

  //取消高级搜索
  cancelSearch = () => {
    const {coworkMainStore} = this.props;
    //coworkMainStore.clearFormFields();
    this.setState({
      showSearchAd: false
    });
  }
  
  resetSearch = () => {
    const { coworkMainStore } = this.props;
    const { logViewCondition } = toJS(coworkMainStore.content);
    let initValues = WeaTools.getParamsByConditions(logViewCondition);
    logViewCondition && logViewCondition.length>0&&logViewCondition.map(c =>{
      c.items.map(fields => {
        if (fields.conditionType == 'DATE') {
          initValues[fields.domkey[0]] = '0';
        } else {
          initValues[fields.domkey[0]] = '';
        }
      });
    });
    this.props.form.setFieldsValue(initValues);
    coworkMainStore.clearFormFields();
  }
  
  back = () => {
    this.props.showLogDialog(false);
    this.cancelSearch();
    this.props.coworkMainStore.clearLogViewCondition();
    this.props.coworkMainStore.logTableStore.tableUpdate('init',{data:[]});
  }
  
  changeHeight = (height) => {
    this.setState({height});
  }

  exportExcel  = () => {
    const {coworkMainStore} = this.props;
    let { id } = coworkMainStore.content;
    coworkMainStore.coworkLogExport({coworkId:id});
  }
}

//表单数据绑定
export default LogDialog = Form.create()(LogDialog);


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/dialog/CoworkLogDialog.js